import { IntegrationType } from "~/types/integrations";

export const getAvailableIntegrations = (currentIntegrationTypes: IntegrationType[]): IntegrationType[] => {
    const vistaCrmType: IntegrationType = "vistacrm";
    const integrations = [vistaCrmType];

    return integrations.filter(integration => !currentIntegrationTypes.includes(integration));
};

export const getTitle = (integrationType: IntegrationType): string => {
    if (integrationType === "vistacrm") {
        return "Vista CRM";
    }

    if (integrationType === "suaquadra_privado") {
        return "SuaQuadra Privado"
    }

    return "";
};
